import React from 'react';
import {
	Button,
	Grid,
	Modal
} from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';

import ChatedModal from '../../../components/modal';

const DEFAULT_STATE = {
	open: false,
	payment: null
};

export class PaymentInfoModal extends ChatedModal {
	constructor (props) {
		super(props);
		this.state = {
			...DEFAULT_STATE
		};
	}

	openModal = (payment) => {
		this.setState({
			open: true,
			payment: payment
		});
	}

	hideModal = () => {
		this.setState({
			...DEFAULT_STATE
		});
	}

	getPaymentMethodInfo(paymentMethodSlug) {
		switch(paymentMethodSlug) {
			case 'shopify_application_charge':
			case 'shopify_recurring_charge':
			case 'shopify_usage_charge':
				return 'Shopify';
			case 'paypal':
				return 'Paypal';
			default:
				return '';
		}
	}

	render() {
		const {payment, open} = this.state;
		const paymentId = _.get(payment, '_id');
		const paymentDate = _.get(payment, 'paid_at', '');
		const formattedPaymentDate = paymentDate === '' ? '-' : moment(paymentDate).format('YYYY-MM-DD hh:mm:ss ([GMT] Z)');

		const serviceStartDate = _.get(payment, 'service_started_at', '');
		const formattedserviceStartDate = serviceStartDate === '' ? '-' : moment(serviceStartDate).format('YYYY-MM-DD') + ' (GMT +00:00)';

		const serviceEndDate = _.get(payment, 'service_ended_at', '');
		const formattedserviceEndDate = serviceEndDate === '' ? '-' : moment(serviceEndDate).format('YYYY-MM-DD') + ' (GMT +00:00)';

		const name = _.get(payment, 'name', '');
		const amount = `$ ${_.get(payment, 'amount', '')}`;
		const paymentMethod = this.getPaymentMethodInfo(_.get(payment, 'payment_method', ''));
		const status = _.get(payment, 'status', '');
		// const description = _.get(payment, 'description', '');

		return (
			<Modal open={ open } closeIcon onClose={ this.hideModal }>
				<Modal.Header>{ name }</Modal.Header>
				<Modal.Content>
					<Grid padded columns='equal'>
						<Grid.Row>
							<Grid.Column className='bold'>Date of Payment</Grid.Column>
							<Grid.Column width={13}>{formattedPaymentDate}</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column className='bold'>Payment ID</Grid.Column>
							<Grid.Column width={13}>{paymentId}</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column className='bold'>Amount</Grid.Column>
							<Grid.Column width={13}>{amount}</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column className='bold'>Service Start Date</Grid.Column>
							<Grid.Column width={13}>{formattedserviceStartDate}</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column className='bold'>Service End Date</Grid.Column>
							<Grid.Column width={13}>{formattedserviceEndDate}</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column className='bold'>Payment Method</Grid.Column>
							<Grid.Column width={13}>{paymentMethod}</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column className='bold'>Status</Grid.Column>
							<Grid.Column width={13}>{status}</Grid.Column>
						</Grid.Row>
					</Grid>
				</Modal.Content>
				<Modal.Actions>
					<Button content='Cancel' onClick={ this.hideModal } />
				</Modal.Actions>
			</Modal>
		);
	}
}

export default PaymentInfoModal;



// WEBPACK FOOTER //
// ./src/containers/dashboard-payments-page/components/payment-info-modal.js